import { Switch } from "react-aria-components"
import styles from "./Toggle.module.css"

interface Props {
  isOn: boolean
  onToggle: () => void
  "aria-label": string
}

/** The Ember `DS::Toggle @whiteCircle={{true}}`, as a react-aria Switch. */
export default function Toggle({ isOn, onToggle, "aria-label": ariaLabel }: Props) {
  return (
    <Switch isSelected={isOn} onChange={onToggle} aria-label={ariaLabel} className={styles.toggle}>
      {({ isSelected }) => (
        <div className={styles["toggle__box"]}>
          <div className={styles["toggle__track"]}>
            <span className={styles["toggle__text"]}>{isSelected ? "ON" : "OFF"}</span>
            <span className={styles["toggle__knob"]} />
          </div>
        </div>
      )}
    </Switch>
  )
}
